module.exports = __webpack_public_path__ + "static/sys_ph06-5b58cbc9157949fa31c55a966bbe1c0b.jpg";